import { Injectable } from '@angular/core';
import { ApiResponseDefault } from '@core/interfaces/request-response/api.dto';
import {
  ActualizarEstadoProductoComandaReq,
  ActualizarMesasPosReq,
  AgregarProductoComandaReq,
  CrearMesaReq,
  EliminarProductoComandaReq,
  MesaRes,
} from '@core/interfaces/request-response/comanda.dto';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class ComandaApiService extends BaseHttpService {
  cargarMesas() {
    return this.withLoader(
      this.httpClient.get<MesaRes[]>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/mesa/cargar`,
      ),
    );
  }
  limpiarMesa(mesa_id: number) {
    return this.withLoader(
      this.httpClient.delete<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/mesa/limpiar/${mesa_id}`,
      ),
    );
  }
  crearMesa(rq: CrearMesaReq) {
    return this.withLoader(
      this.httpClient.post<MesaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/mesa/crear`,
        rq,
      ),
    );
  }
  actualizarMesa(mesa_id: number, rq: CrearMesaReq) {
    return this.withLoader(
      this.httpClient.put<MesaRes>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/mesa/editar/${mesa_id}`,
        rq,
      ),
    );
  }
  actualizarPosicionesMesas(rq: ActualizarMesasPosReq) {
    return this.withLoader(
      this.httpClient.put<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/mesa/guardar-posiciones`,
        rq,
      ),
    );
  }
  agregarProductosComanda(rq: AgregarProductoComandaReq) {
    return this.withLoader(
      this.httpClient.post<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/agregar-productos`,
        rq,
      ),
    );
  }
  actualizarEstadoProductoComanda(rq: ActualizarEstadoProductoComandaReq) {
    return this.withLoader(
      this.httpClient.put<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/actualizar-estado-producto`,
        rq,
      ),
    );
  }
  eliminarProductoComanda(rq: EliminarProductoComandaReq) {
    return this.withLoader(
      this.httpClient.delete<ApiResponseDefault>(
        `${environment.apiUrl}${environment.apiPreFix}/comandas/eliminar-producto`,
        {
          body: rq,
        },
      ),
    );
  }
}
